import { RazorInputField, toast } from "../../../components/razor-reuse";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReuseModal from "../../../components/fragment/modal/ReuseModal";
import { validateEmail } from "../../../helper/helpers";
import { MultiValueRemoveProps, components } from "react-select";
import RootState from "../../../redux/type";
import { editAdminUserInvite } from "../../../redux/users";
import {
  arraysHaveDifferences,
  reactSelectStyleTable,
} from "../../../utils/Helper";

interface myComponentProps {
  onClose?: () => void;
  onFinish?: () => void;
  visible?: boolean;
  detail?: any;
}

const ViewUserModal = ({
  onClose,
  visible,
  onFinish,
  detail,
}: myComponentProps) => {
  const { all_roles_drop } = useSelector((state: RootState) => state.roles);
  const { loading_users } = useSelector((state: RootState) => state.users);
  const dispatch = useDispatch();

  type detailProps = {
    first_name: string;
    last_name: string;
    roles: string[];
    email: string;
    gender: any;
  };
  const [details, setDetails] = useState<detailProps>({
    first_name: "",
    last_name: "",
    roles: [],
    email: "",
    gender: "",
  });

  // Define the type for options
  type OptionType = {
    label: string;
    value: string;
    disableRemove?: boolean; // Optional flag to control removal
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const obj = { ...details, [name]: value };
    setDetails(obj);
  };

  //   const genderOptions = [
  //     { label: "Male", value: "Male" },
  //     { label: "Female", value: "Female" },
  //   ];

  const getListUserId = (list: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => chi?.id);
      return newList;
    }
  };

  const addLabelValue = (list?: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => {
        return { ...chi, label: chi?.name, value: chi?.id };
      });
      return newList;
    }
  };

  useEffect(() => {
    if (visible) {
      setDetails((prev) => {
        return {
          ...prev,
          first_name: detail?.first_name,
          last_name: detail?.last_name,
          roles: addLabelValue(detail?.roles),
          email: detail?.email,
        };
      });
    }
  }, [visible]);

  const handleSubmit = async () => {
    if (!validateEmail(details?.email)) {
      toast.error("Invalid email address!", {
        theme: "colored",
      });
      return;
    }
    const obj = {
      ...details,
      roles: getListUserId(details?.roles),
      gender: details?.gender?.label,
      admin_user_id: detail?.id,
    };
    const data = await dispatch(editAdminUserInvite(obj) as any);

    if (data?.payload?.data?.status) {
      setDetails({
        first_name: "",
        last_name: "",
        roles: [],
        email: "",
        gender: "",
      });
      onFinish?.();
    }
  };

  const getListUserRole = (list: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => chi?.name);
      return newList;
    }
  };

  const addRemoveCancelList = (list?: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => {
        return {
          ...chi,
          disableRemove: chi?.label === "super_admin" ? true : false,
        };
      });
      return newList;
    }
  };

  // Custom MultiValueRemove component
  const CustomMultiValueRemove = (props: MultiValueRemoveProps<OptionType>) => {
    // Disable the remove icon if `disableRemove` is true for the option
    if (props.data.disableRemove) {
      return null;
    }
    return <components.MultiValueRemove {...props} />;
  };

  return (
    <>
      <ReuseModal
        title="View User Info"
        btnLabel="Update user"
        visible={visible}
        onClose={onClose}
        hideBtn
        disable={
          detail?.first_name === details?.first_name &&
          detail?.last_name === details?.last_name &&
          detail?.email === details?.email &&
          !arraysHaveDifferences(
            getListUserId(addLabelValue(detail?.roles)),
            getListUserId(details?.roles)
          )
        }
        loading={loading_users}
        onBtnClick={handleSubmit}
      >
        {/* input here */}
        <RazorInputField
          color="black-light"
          type="text"
          placeholder="Enter first name"
          label="First Name"
          style={{ position: "relative", zIndex: 1 }}
          name={`first_name`}
          value={details?.first_name}
          onChange={handleChange}
          disabled
        />
        {/* input here */}
        {/* input here */}
        <RazorInputField
          color="black-light"
          type="text"
          placeholder="Enter last name"
          label="Last Name"
          style={{ position: "relative", zIndex: 1 }}
          name={`last_name`}
          value={details?.last_name}
          onChange={handleChange}
          disabled
        />
        {/* input here */}
        {/* input here */}
        <RazorInputField
          color="black-light"
          type="email"
          placeholder="Enter email"
          label="Email"
          style={{ position: "relative", zIndex: 1 }}
          name={`email`}
          value={details?.email}
          onChange={handleChange}
          disabled
        />
        {/* input here */}
        {/* input here */}
        {/* <RazorInputField
          color="black-light"
          type="select"
          placeholder="Select gender"
          label="Select Gender"
          style={{ position: "relative", zIndex: 2 }}
          menuPlacement={`top`}
          selectOption={genderOptions}
          selectStyles={reactSelectStyleTable}
          value={details?.gender}
          onChange={(e: any) => {
            setDetails((prev) => {
              return { ...prev, gender: e };
            });
          }}
        /> */}
        {/* input here */}
        {/* input here */}
        <RazorInputField
          color="black-light"
          type="select"
          placeholder="Select role(s)"
          label="Assign Role"
          style={{ position: "relative", zIndex: 3 }}
          menuPlacement={`top`}
          selectOption={addRemoveCancelList(all_roles_drop)}
          multi
          selectStyles={reactSelectStyleTable}
          value={details?.roles}
          onChange={(e: any) => {
            if (getListUserRole(e)?.includes("super_admin")) {
              setDetails((prev) => {
                return { ...prev, roles: e };
              });
            }
          }}
          disabled
          //   components={{ MultiValueRemove: CustomMultiValueRemove }}
        />
        {/* input here */}
      </ReuseModal>
    </>
  );
};

export default ViewUserModal;
